var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 4,
    fill: "#9D4EDD",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_26758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4983 11.4525C19.4713 11.4525 20.2602 10.6637 20.2602 9.69063C20.2602 8.71755 19.4713 7.92871 18.4983 7.92871C17.5252 7.92871 16.7363 8.71755 16.7363 9.69063C16.7363 10.6637 17.5252 11.4525 18.4983 11.4525Z",
    fill: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4983 20.2621C19.4713 20.2621 20.2602 19.4733 20.2602 18.5002C20.2602 17.5271 19.4713 16.7383 18.4983 16.7383C17.5252 16.7383 16.7363 17.5271 16.7363 18.5002C16.7363 19.4733 17.5252 20.2621 18.4983 20.2621Z",
    fill: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4983 29.0717C19.4713 29.0717 20.2602 28.2829 20.2602 27.3098C20.2602 26.3367 19.4713 25.5479 18.4983 25.5479C17.5252 25.5479 16.7363 26.3367 16.7363 27.3098C16.7363 28.2829 17.5252 29.0717 18.4983 29.0717Z",
    fill: "#9D4EDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_26758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1429,
    height: 21.1429,
    fill: "white",
    transform: "translate(7.92773 7.92871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.b1b37b30555e709c7105b4af45b74702.svg";
export { ForwardRef as ReactComponent };